import Index from '@/pages/messages/Index'

export default {
  path: 'messages/index',
  component: Index
}